module.exports = __webpack_public_path__ + "img/Pop-Up-Camper-Mobile.da533e29.jpg";